import { Service, ServiceFromSSR } from '@zapier/services/esm/types';

export const getServiceIds = (services: Array<Service | ServiceFromSSR>) => {
  if (!services) return undefined;

  return services
    .map(service => service && service.id)
    .filter(id => Boolean(id));
};

export default getServiceIds;
